<div class="wvThermo" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'" *ngIf="!slideError && !!thermoData && thermoState">
    <div class="wvThermometer FlexColNoWrap">
        <div class="wvThermoDataBox wvThermoDataBox{{moduleKey}} hidden">{{thermoData?.Metric_Data.MetricDisplayValue}}</div>
        <div class="wvThermoBar wvThermoBar{{moduleKey}}" [ngStyle]="getNewObjectiveColorStyle()"></div>
    </div>

    <div class="wvThermoTitleArea">
        <div class="wvThermoTitle txtOverflow" [ngStyle]="{visibility: (!!thermoState && thermoState.ThermometerTitle == '') ? 'hidden' : 'visible'}">{{thermoState?.ThermometerTitle}}</div>
        <div class="wvThermoMetric txtOverflow">{{thermoMetricName}}</div>
    </div>
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
